import React, {useState, useEffect, useRef} from "react";
import './PastPage.css'
import {languageManager} from "../../utils/i18n";
import {Link} from "react-router-dom";
import image_kyivliquor from '../../assets/images/past/kyivliquor.jpg'
import image_brickstyle from '../../assets/images/past/brickstyle.jpg'
import image_kopyriv from '../../assets/images/past/kopyriv.jpg'
import image_kudriavets from '../../assets/images/past/kudriavets.jpg'
import image_history from '../../assets/images/past/history.jpg'
import image_bessmertnyi from '../../assets/images/past/bessmertnyi.jpg'
import image_archzone from '../../assets/images/past/archzone.jpg'
import video_revit from '../../assets/images/past/revit.webm'
import image_revit from '../../assets/images/past/revit.jpg'
import image_culture from '../../assets/images/past/culture.jpg'

const images = {
	kyivliquor: {
		content: image_kyivliquor,
		position: 'left'
	},
	brickstyle: {
		content: image_brickstyle,
		position: 'left'
	},
	kopyriv: {
		content: image_kopyriv,
		position: 'right'
	},
	kudriavets: {
		content: image_kudriavets,
		position: 'left'
	},
	history: {
		content: image_history,
		position: 'left'
	},
	bessmertnyi: {
		content: image_bessmertnyi,
		position: 'left'
	},
	archzone: {
		content: image_archzone,
		position: 'left'
	},
	revit: {
		content: video_revit,
		poster: image_revit,
		position: 'left'
	},
	culture: {
		content: image_culture,
		position: 'left'
	},
};

const PastPage = () => {
	const [hoveredElement, setHoveredElement] = useState(null);
	const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
	const [isMobile, setIsMobile] = useState(false);
	const imageRef = useRef(null);
	const hoverElementRef = useRef(null);

	const t = languageManager.t.bind(languageManager);

	useEffect(() => {
		const checkIfMobile = () => {
			setIsMobile(window.innerWidth <= 768);
		};

		checkIfMobile();
		window.addEventListener('resize', checkIfMobile);

		return () => {
			window.removeEventListener('resize', checkIfMobile);
		};
	}, []);

	useEffect(() => {
		const handleDocumentClick = (e) => {
			if (isMobile && hoveredElement) {
				if (imageRef.current && !imageRef.current.contains(e.target) &&
					(!hoverElementRef.current || !hoverElementRef.current.contains(e.target))) {
					setHoveredElement(null);
				}
			}
		};

		document.addEventListener('click', handleDocumentClick);

		return () => {
			document.removeEventListener('click', handleDocumentClick);
		};
	}, [isMobile, hoveredElement]);

	const calculateImagePosition = (element) => {
		if (!element) return { x: 0, y: 0 };

		const rect = element.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

		const viewportWidth = window.innerWidth;
		const viewportHeight = window.innerHeight;

		const imageWidth = 400;
		const imageHeight = 300;

		const offset = 5;

		let x, y;

		if (isMobile) {
			x = viewportWidth / 2 - imageWidth / 2;
			y = viewportHeight / 2 - imageHeight / 2 + scrollTop;
		} else {
			const spaceLeft = rect.left;
			const spaceRight = viewportWidth - rect.right;
			const spaceTop = rect.top - 32;
			const spaceBottom = viewportHeight - rect.bottom - 32;

			if (spaceBottom > imageHeight) {
				y = rect.bottom + scrollTop
			} else if (spaceTop > imageHeight) {
				y = rect.top + scrollTop - imageHeight
			} else {
				y = rect.top + scrollTop;
			}
			if (spaceRight > imageWidth + offset) {
				x = rect.right + scrollLeft + offset;
			} else if (spaceLeft > imageWidth + offset) {
				x = rect.left + scrollLeft - imageWidth - offset;
			} else {
				x = rect.left + scrollLeft + (rect.width / 2) - (imageWidth / 2);
			}

			if (x < 0) x = offset;
			if (x + imageWidth > viewportWidth) x = viewportWidth - imageWidth - offset;
			if (y < scrollTop) y = scrollTop + offset;
			if (y + imageHeight > scrollTop + viewportHeight) y = scrollTop + viewportHeight - imageHeight - offset;
		}

		return { x, y };
	};

	const handleHover = (id, e) => {
		if (isMobile) return;
		setHoveredElement(id);
		hoverElementRef.current = e.currentTarget;
		setImagePosition(calculateImagePosition(e.currentTarget, id));
	};

	const handleClick = (id, e) => {
		if (!isMobile) return;
		e.stopPropagation();

		if (hoveredElement === id) {
			setHoveredElement(null);
		} else {
			setHoveredElement(id);
			hoverElementRef.current = e.currentTarget;
			setImagePosition(calculateImagePosition(e.currentTarget, id));
		}
	};

	const handleHoverEnd = () => {
		if (!isMobile) {
			setHoveredElement(null);
		}
	};

	const parseInteractiveText = (text) => {
		if (!text) return null;
		const result = [];
		let remainingText = text;
		let currentKey = 0;

		const findNextInteractiveElement = (text) => {
			const linkStart = text.indexOf('<link:');
			const hoverStart = text.indexOf('<hover:');
			if (linkStart === -1 && hoverStart === -1) {
				return { type: null, index: -1 };
			}

			if (linkStart === -1) return { type: 'hover', index: hoverStart };
			if (hoverStart === -1) return { type: 'link', index: linkStart };

			return linkStart < hoverStart
				? { type: 'link', index: linkStart }
				: { type: 'hover', index: hoverStart };
		};

		while (remainingText.length > 0) {
			const { type, index } = findNextInteractiveElement(remainingText);

			if (index === -1) {
				result.push(remainingText);
				break;
			}

			if (index > 0) {
				result.push(remainingText.substring(0, index));
			}

			if (type === 'link') {
				const fullTagMatch = remainingText.match(/<link:([^>]+)>(.*?)<\/link:\1>/);
				if (fullTagMatch) {
					const [fullMatch, id, content] = fullTagMatch;

					let url = '';
					if (id === 'kovalska') url = 'https://kovalska.com/main';
					if (id === 'chipperfield') url = 'https://davidchipperfield.com';

					result.push(
						<Link key={`link-${id}-${currentKey++}`} to={url} className="interactive-link" target='_blank'>
							{content}
						</Link>
					);

					remainingText = remainingText.substring(fullTagMatch.index + fullMatch.length);
				} else {
					console.warn('Не знайдено закриваючий тег для link:', remainingText.substring(index, index + 50));
					result.push(remainingText);
					break;
				}
			}

			if (type === 'hover') {
				const fullTagMatch = remainingText.match(/<hover:([^>]+)>(.*?)<\/hover:\1>/);
				if (fullTagMatch) {
					const [fullMatch, id, content] = fullTagMatch;

					if (images[id]) {
						result.push(
							<span
								key={`hover-${id}-${currentKey++}`}
								className="hover-element"
								data-hover-id={id}
								onMouseEnter={(e) => handleHover(id, e)}
								onMouseLeave={handleHoverEnd}
								onClick={(e) => handleClick(id, e)}
							>
								{content}
							</span>
						);
					} else {
						console.warn(`Зображення для елемента hover з id "${id}" не знайдено`);
						result.push(content);
					}

					remainingText = remainingText.substring(fullTagMatch.index + fullMatch.length);
				} else {
					console.warn('Не знайдено закриваючий тег для hover:', remainingText.substring(index, index + 50));
					result.push(remainingText);
					break;
				}
			}
		}

		return result;
	};

	const renderMonumentsList = () => {
		const monumentsList = t('past.content.monumentsList');
		if (!Array.isArray(monumentsList)) return null;

		return (
				monumentsList.map((item) => (
						parseInteractiveText(item))));
	};

	return (
		<div className="past">
			<div className="container">
				<div className="past__content">
					{parseInteractiveText(t('past.content.intro'))}
					{parseInteractiveText(t('past.content.history1'))}
					{parseInteractiveText(t('past.content.architect'))}
					{parseInteractiveText(t('past.content.style'))}
					{parseInteractiveText(t('past.content.merchantStyle'))}
					{parseInteractiveText(t('past.content.location'))}
					{parseInteractiveText(t('past.content.ancientHistory'))}
					{parseInteractiveText(t('past.content.industry'))}
					{parseInteractiveText(t('past.content.monuments'))}
					{renderMonumentsList()}
					{parseInteractiveText(t('past.content.recent'))}
					{parseInteractiveText(t('past.content.future'))}
				</div>

				{hoveredElement && images[hoveredElement] && (
					<div
						className={`hover-image-container ${isMobile ? 'mobile' : ''}`}
						style={isMobile ? {} : { top: `${imagePosition.y}px`, left: `${imagePosition.x}px` }}
						ref={imageRef}
					>
					{/*	{media.map((item, index) => (*/}
					{/*	item.includes('.mp4') ? (*/}
					{/*		<video key={index} autoPlay*/}
					{/*		       loop*/}
					{/*		       muted*/}
					{/*		       playsInline>*/}
					{/*			<source src={item} type="video/mp4" />*/}
					{/*			Your browser does not support the video tag.*/}
					{/*		</video>*/}
					{/*	) : (*/}
					{/*		<img key={index} src={item} alt={`Pop-Up ${index + 1}`} />*/}
					{/*	)*/}
					{/*))}*/}
						{images[hoveredElement].content.includes('.webm') ? (
							<video autoPlay loop muted playsInline className="hover-image" poster={images[hoveredElement].poster}>
								<source src={images[hoveredElement].content} type="video/mp4" />
								Your browser does not support the video tag.
							</video>
						) : (
							<img
								src={images[hoveredElement].content}
								alt={`Зображення: ${hoveredElement}`}
								className="hover-image"
							/>
						)
						}

					</div>
				)}
			</div>
		</div>
	);
};

export default PastPage;